import React from 'react';
import { Loader as LoaderIcon } from 'lucide-react';

interface LoadingStateProps {
  timeInSeconds?: number;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  timeInSeconds = 10 // Not used with spinner implementation
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="p-8 flex flex-col items-center justify-center">
        <div className="w-full max-w-xs flex flex-col items-center">
          <LoaderIcon size={36} className="text-purple-600 animate-spin mb-4" />
          <div className="text-center">
            <span className="text-sm font-semibold text-purple-600">
              Generating Video
            </span>
          </div>
          <p className="mt-4 text-sm text-gray-500 text-center">
            This may take up to 30 seconds. Please do not close the tab or refresh the page.
          </p>
        </div>
      </div>
    </div>
  );
};
